import React, {useState} from 'react'

import {Tabs as HedwigTabs, Container, Accordion, StyledHtml, Link, LinkList, Grid, Text} from "@postenbring/hedwig-react";


const FaqListsAccordion = ({lists}) => {
    const [openItem, setOpenItem] = useState(lists.length === 1 ? 0 : undefined);

    function toggle(item) {
        setOpenItem(item === openItem ? undefined : item);
    }

    return (
        <Accordion>
            {lists.map(
                (item, i) => (
                    <Accordion.Item key={i}
                                    onOpenChange={() => toggle(i)}
                                    open={openItem === i}
                    >
                        <Accordion.Header>{item.question}</Accordion.Header>
                        <Accordion.Content>
                            <StyledHtml dangerouslySetInnerHTML={{__html: item.answer}}/>
                        </Accordion.Content>
                    </Accordion.Item>
                )
            )}
        </Accordion>
    )
}

const Faq = ({title, preface, lists}) => (
    (title || preface || lists) &&
    <section className="hds-mt-40-48 hds-mb-32">
        {title && <Text className="hds-mb-16" variant="h3">{title}</Text>}
        {preface && <Text className="hds-mb-16" variant="body">{preface}</Text>}
        {lists?.lists && lists?.lists.length > 0 &&
            <FaqListsAccordion lists={lists.lists}/>
        }
    </section>
)

const TabLinkList = ({linkList, linkListTitle}) => (
    linkList &&

    <div className="hds-mb-24 hds-mt-48">
        {linkListTitle &&
            <div className="hds-mb-8">
                <Text variant="h3" as="h2">{linkListTitle}</Text>
            </div>
        }
        <LinkList>
            {
                linkList.map((link, i) => (
                    <li key={i}>
                        <Link href={(link.url || '').trim() || '#'} target={link.newTab ? '_blank' : ''}>{link.linkText}</Link>
                    </li>
                ))
            }
        </LinkList>
    </div>
)


const PageDescription = ({pageDescription}) => (
    pageDescription &&

    <Grid className="hds-mt-20-24 hds-mb-20-24" gapY="24-32" span={{initial: 12, large: 8}}>
        <Grid.Item>
            <p>{pageDescription}</p>
        </Grid.Item>
    </Grid>
)

const WysiwygBlock = ({htmlText}) => (
    htmlText &&

    <StyledHtml dangerouslySetInnerHTML={{__html: htmlText}}/>
)

const DateField = ({dateField}) => (
    <div>
        {
            dateField &&
            <Text variant="body-small" className="hds-mb-24-32">
                <time dateTime={dateField}>{dateField}</time>
            </Text>
        }
    </div>
)

const TabsAndLinks = ({infoPage, pageLinks, infoPageLinksHeading}) => {
    let hasSinglePageLink = false;

    if (pageLinks?.links) {
        if (pageLinks.links.length > 1) {
            infoPage.push({
                info: {
                    id: "__infoPageLinksHeading__",
                    text: pageLinks.title || infoPageLinksHeading
                },
                data: [
                    {pageLinks: pageLinks}
                ]
            })
        } else if (pageLinks.links.length === 1) {
            hasSinglePageLink = true;
        }
    }

    return <div className="hds-mt-48-64 hds-mb-120-160">
        <HedwigTabs defaultTab={infoPage[0]?.info?.id}>
            {
                infoPage && infoPage.length > 1 &&

                <HedwigTabs.List className="infopage-tabslist">
                    {infoPage.map(
                        (tabContent) => (
                            <HedwigTabs.Tab key={tabContent?.info?.id} tabId={tabContent?.info?.id}>
                                {tabContent?.info?.text}
                            </HedwigTabs.Tab>
                        )
                    )}
                </HedwigTabs.List>
            }
            <Grid span={{initial: 12, large: 8}}>
                <Grid.Item>
                    {hasSinglePageLink &&
                        <PageLinks pageLinks={pageLinks} />
                    }
                    {
                        infoPage &&

                        <HedwigTabs.Contents>
                            {infoPage.map(
                                (tabContent) => (
                                    <HedwigTabs.Content key={tabContent?.info?.id} forTabId={tabContent?.info?.id}>
                                        {tabContent?.data &&
                                            tabContent.data.map(
                                                (tab, i) => <>
                                                    <WysiwygBlock key={i} htmlText={tab.content}/>
                                                    <Faq key={i} {...tab.faq} />
                                                    <TabLinkList key={i} linkList={tab.linkList}
                                                                 linkListTitle={tab.linkListTitle}/>
                                                    <PageLinks pageLinks={tab.pageLinks}/>
                                                </>
                                            )
                                        }
                                    </HedwigTabs.Content>
                                )
                            )}
                        </HedwigTabs.Contents>
                    }
                </Grid.Item>
            </Grid>
        </HedwigTabs>
    </div>
}

const PageLinks = ({pageLinks}) => (
    pageLinks &&

    <nav className="hds-mt-64">
        {
            pageLinks.title &&

            <Text variant="h3" className="hds-mb-8">{pageLinks.title}</Text>
        }
        {
            (pageLinks.links && pageLinks.links.length > 0) &&

            <LinkList>
                {
                    pageLinks.links.map((link, i) => (
                        <li key={i}>
                            <Link href={link.url}
                                  target={link.newTab ? '_blank' : ''}
                            >
                                {link.linkText}
                            </Link>
                        </li>
                    ))

                }
            </LinkList>
        }
    </nav>
)

const PageTitle = ({
                       pageTitle
                   }) => (
    pageTitle &&

    <Text className="hds-mt-48-64" variant="h1">{pageTitle}</Text>
)

export const InfoPage = ({
                             pageTitle,
                             pageDescription,
                             dateField,
                             pageLinks,
                             infoPage,
                             infoPageLinksHeading
                         }) => (
    <Container as="section">
        <PageTitle pageTitle={pageTitle}/>
        <PageDescription pageDescription={pageDescription}/>
        <DateField dateField={dateField}/>
        <TabsAndLinks infoPage={infoPage}
                      pageLinks={pageLinks}
                      infoPageLinksHeading={infoPageLinksHeading}
        />
    </Container>
)

// <PageLinks pageLinks={pageLinks}/>
